<crowdctrl-unauthenticated-page [pageTitle]="pageTitle" [showFooter]="false" defaultHref="/login">
  <div class="about-project">
    <crowdctrl-unauth-page-intro>
      <h1 crowdctrlUnauthIntroTitle>Contact</h1>
      <p crowdctrlUnauthIntroLead>Questions about CrowdCTRL, access, or demos.</p>
    </crowdctrl-unauth-page-intro>

    @if (showInlineForm) {
      <crowdctrl-standard-form
        heading="Send a message"
        headingId="contact-form"
        [errorMessage]="errorMessage"
      >
        <p crowdctrlFormSummary class="crowdctrl-form-layout__description">
          Wanting to set up your team on CrowdCTRL? Use
          <a
            href="/register-interest"
            class="about-project__inline-link"
            (click)="unauthNav.forward($event, '/register-interest')"
            >Register interest</a
          >
          instead of this form.
        </p>
        <form [formGroup]="contactForm" (ngSubmit)="onSubmit()" novalidate>
          <div class="crowdctrl-form-fields">
            <crowdctrl-form-select-field
              controlName="reason"
              label="Reason for contact"
              mode="md"
              fill="outline"
              interface="popover"
              placeholder="Select a reason"
              [options]="contactReasonSelectOptions"
              [invalid]="submitted && contactForm.controls.reason.invalid"
              [hint]="submitted && contactForm.controls.reason.invalid ? fieldError('reason') : ''"
            ></crowdctrl-form-select-field>
            <crowdctrl-form-textarea-field
              controlName="message"
              placeholder="Message"
              [ariaLabel]="'Message'"
              autocapitalize="sentences"
              [rows]="5"
              [maxlength]="maxMessageLen"
              [invalid]="submitted && contactForm.controls.message.invalid"
              [hint]="
                submitted && contactForm.controls.message.invalid ? fieldError('message') : ''
              "
            ></crowdctrl-form-textarea-field>
            <crowdctrl-form-input-field
              controlName="name"
              label="Name"
              autocomplete="name"
              autocapitalize="sentences"
              [maxlength]="maxNameLen"
              inputmode="text"
              [invalid]="submitted && contactForm.controls.name.invalid"
              [hint]="submitted && contactForm.controls.name.invalid ? fieldError('name') : ''"
            ></crowdctrl-form-input-field>
            <crowdctrl-form-input-field
              controlName="email"
              label="Email"
              type="email"
              autocomplete="email"
              autocapitalize="off"
              inputmode="email"
              [maxlength]="maxEmailLen"
              [invalid]="submitted && contactForm.controls.email.invalid"
              [hint]="submitted && contactForm.controls.email.invalid ? fieldError('email') : ''"
            ></crowdctrl-form-input-field>
          </div>
          <ion-note class="crowdctrl-form-layout__note">
            This site is protected by reCAPTCHA and the Google
            <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer"
              >Privacy Policy</a
            >
            and
            <a href="https://policies.google.com/terms" target="_blank" rel="noopener noreferrer"
              >Terms of Service</a
            >
            apply.
          </ion-note>
          <crowdctrl-form-submit-bar>
            <crowdctrl-loading-button
              crowdctrlFormPrimaryAction
              type="submit"
              expand="block"
              [loading]="submitting"
              loadingText="Sending..."
            >
              Send
            </crowdctrl-loading-button>
          </crowdctrl-form-submit-bar>
        </form>
      </crowdctrl-standard-form>
    }

    @if (contactMailtoHref) {
      <section class="about-project__section" aria-labelledby="contact-email">
        <h2 id="contact-email" class="about-project__heading">Email</h2>
        <p class="about-project__text">
          <a [href]="contactMailtoHref" class="about-project__signin-link">Send an email</a>
        </p>
        <p class="about-project__text">
          Your mail app will open with a subject line filled in. Add enough detail so we can help.
        </p>
      </section>
    } @else if (!showInlineForm) {
      <section class="about-project__section" aria-labelledby="contact-no-email">
        <h2 id="contact-no-email" class="about-project__heading">
          No contact options on this deployment
        </h2>
        <p class="about-project__text">
          Configure <code>apiUrl</code> and <code>recaptchaSiteKey</code>, or set a contact email.
          For product background, see the
          <a
            href="/about"
            class="about-project__inline-link"
            (click)="unauthNav.forward($event, '/about')"
            >About {{ appName }}</a
          >
          page.
        </p>
      </section>
    }

    <section class="about-project__section" aria-labelledby="contact-access">
      <h2 id="contact-access" class="about-project__heading">Team access</h2>
      <p class="about-project__text">
        If your workplace already uses {{ appName }}, ask your administrator to invite you to the
        app. When you have been added,
        <a
          href="/login"
          class="about-project__inline-link"
          (click)="unauthNav.forward($event, '/login')"
          >sign in</a
        >.
      </p>
    </section>

    <a
      href="/login"
      class="about-project__signin-link"
      (click)="unauthNav.forward($event, '/login')"
      >Sign in</a
    >
  </div>
</crowdctrl-unauthenticated-page>
